import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { memo } from "react";

interface MealTitleProps {
  title: string;
  className?: string;
}

export const MealTitle = memo(function MealTitle({ title, className }: MealTitleProps) {
  return <h6 className={cn(textVariants.listItemTitle, "text-black", className)}>{title}</h6>;
});
